<template>
  <el-dialog title="回复评价" v-model="visible" width="600px">
    <el-form ref="ruleForm" :model="addRow" label-width="100px">
      <form-item-rule label="回复内容" prop="content">
        <el-input type="textarea" :rows="5" v-model="addRow.content"></el-input>
      </form-item-rule>
    </el-form>
    <span slot="footer" class="dialog-footer">
       <el-button @click="visible = false">取 消</el-button>
       <el-button type="primary" @click="doSave()">确 定</el-button>
      </span>
  </el-dialog>
</template>

<script>

import FormItemRule from "@/components/el/form-item-rule.vue";

export default {
  name: "reply-evaluate",
  components: {FormItemRule},
  data() {
    return {
      visible:false,
      addRow:{id:"",content:""},
    }
  },
  mixins: [tableBase],
  methods: {
    open(row){
      this.addRow.id = row.id;
      this.visible = true;
    },
    doSave(){
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          this.simplePost("/api/mgr/shop/business/order/replyOrderEvaluate",this.addRow,res=>{
            this.$emit('load');
            this.visible = false;
          })
        }
      });
    }
  },
  mounted() {

  }
}
</script>


<style lang="less" scoped>
</style>
